export default "/assets/logo-white.06fa86bdfc22b718ffe4637a80b32fa9.png";